import React from 'react';

const Sidebar = ({ activeTab, setActiveTab }) => (
  <nav className="sidebar" aria-label="Main navigation">
    <ul>
      <li
        className={activeTab === "main" ? "active" : ""}
        onClick={() => setActiveTab("main")}
        role="button"
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setActiveTab("main")}
        aria-current={activeTab === "main" ? "page" : undefined}
      >
        Main
      </li>
      <li
        className={activeTab === "access-key" ? "active" : ""}
        onClick={() => setActiveTab("access-key")}
        role="button"
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setActiveTab("access-key")}
        aria-current={activeTab === "access-key" ? "page" : undefined}
      >
        Access Key
      </li>
      <li
        className={activeTab === "how-to-use" ? "active" : ""}
        onClick={() => setActiveTab("how-to-use")}
        role="button"
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setActiveTab("how-to-use")}
        aria-current={activeTab === "how-to-use" ? "page" : undefined}
      >
        Using the Service
      </li>
      <li
        className={activeTab === "metadata" ? "active" : ""}
        onClick={() => setActiveTab("metadata")}
        role="button"
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setActiveTab("metadata")}
        aria-current={activeTab === "metadata" ? "page" : undefined}
      >
        Metadata
      </li>
    </ul>
  </nav>
);

export default Sidebar;